import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './Header.scss';
import AscendLogo from '../../assets/icons/AscendLogo.svg';
import { useExperiments } from '@wix/wix-experiments-react';
import Premium from 'wix-ui-icons-common/Premium';
import { TextButton } from 'wix-style-react';
import { getWixPremiumPlans } from '../../services/urls';
import { navigateToUrl } from '../../services/window-utils';
import { biLogger } from '../../globals';

export interface HeaderProps {
  isWixPremiumSite: boolean;
  msid: string;
}

export const Header: React.FunctionComponent<HeaderProps> = (
  props: HeaderProps,
) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const ascendPackagePickerHeader = experiments.get(
    'specs.abTranslate.ascend.abSpec-ascendPackagePickerHeader',
  );

  const isWixPremiumSite = props.isWixPremiumSite;

  const navigateToWixPlans = () => {
    biLogger.buttonClicked({ msid: props.msid, button_name: 'premium' });
    navigateToUrl(getWixPremiumPlans(props.msid));
  };

  return (
    <div className={s.strip} data-hook="header-strip">
      <div className={s.root} data-hook="header">
        <div className={s.logo} data-hook="header-logo">
          <img src={AscendLogo} alt="Ascend Logo" />
        </div>
        <h1 className={s.title} data-hook="header-title">
          {ascendPackagePickerHeader > 0
            ? t(
                `header.title|abTranslate_${ascendPackagePickerHeader}|ascendPackagePickerHeader`,
              )
            : t('header.title')}
        </h1>
        <h2 className={s.subTitle} data-hook="header-subTitle">
          {ascendPackagePickerHeader > 0
            ? t(
                `header.subTitle|abTranslate_${ascendPackagePickerHeader}|ascendPackagePickerHeader`,
              )
            : t('header.subTitle')}
        </h2>
        <div className={s.returnTerm} data-hook="header-returnTerm">
          {t('header.returnTerm')}
        </div>
        {!isWixPremiumSite ? (
          <div className={s.premiumBanner} data-hook="header-premiumBanner">
            <div className={s.icon}>
              <Premium
                data-hook="header-premiumBanner-icon"
                color="#AA4DC8"
                size="30px"
              />
            </div>
            <div data-hook="header-premiumBanner-message">
              {t('header.premiumMessage')}
            </div>
            <div className={s.planButton}>
              <TextButton
                as="button"
                onClick={navigateToWixPlans}
                underline="always"
                skin="premium"
                size="small"
                dataHook="header-premiumBanner-planButton"
              >
                {t('header.premiumButton')}
              </TextButton>
            </div>
          </div>
        ) : (
          <div className={s.noPremiumBanner} />
        )}
      </div>
    </div>
  );
};

export default Header;
